import { render, staticRenderFns } from "./SlideTextWall.vue?vue&type=template&id=2fe21833&"
import script from "./SlideTextWall.vue?vue&type=script&lang=js&"
export * from "./SlideTextWall.vue?vue&type=script&lang=js&"
import style0 from "./SlideTextWall.vue?vue&type=style&index=0&id=2fe21833&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports